<template>
<div>
    <div class="justify-between items-center flex flex-wrap gap-3 w-full pb-5">
        <div class="flex flex-col">
            <h2 class="font-display font-bold text-xl text-ink">
                <slot name="title" />
            </h2>
            <slot name="breadcrumb" />
        </div>

        <div>
            <slot name="actions" />
        </div>
    </div>
    <slot />
</div>
</template>

<script>
export default {
    inheritAttrs: false,
};
</script>
